import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
const addLeadingZero = (value) => {
    if (typeof value === 'string')
        return value;
    return value < 10 ? '0' + value : Number(value).toString();
};
export const createPaginationTabs = (activeIndex = 1, maxIndex = 1, indexAriaLabel) => {
    if (maxIndex < 6) {
        return {
            currentIndex: activeIndex - 1,
            list: new Array(maxIndex).fill(0).map((value, index) => ({
                label: addLeadingZero(index + 1),
                disabled: false,
            })),
        };
    }
    let list = [1];
    const FILL = 2;
    // determine pre-set of number before activeIndex
    const middleStart = Math.min(Math.max(activeIndex - 1, 3), maxIndex - FILL - 2);
    const middle1 = new Array(FILL).fill(0).map((_, index) => middleStart + index);
    // determine post-set of number before activeIndex
    const middleEndStart = Math.min(middle1[middle1.length - 1], maxIndex - FILL);
    const middle2 = new Array(FILL).fill(0).map((_, index) => middleEndStart + index);
    // merge and remove duplicates
    const middle = [...middle1, ...middle2].reduce((merged, index) => {
        if (merged.indexOf(index) === -1) {
            merged.push(index);
        }
        return merged;
    }, []);
    const preDifference = 1 - middle[0];
    // determine when to show the left ellipsis or show the number that is just between `1 ... 3`
    const preEllipsis = preDifference < -1 ? [preDifference === -FILL ? middle[0] - 1 : '...'] : [];
    const postDifference = maxIndex - middle[middle.length - 1];
    // determine when to show the right ellipsis or show the number that is just between `(maxIndex - 2) ... maxIndex`
    const postEllipsis = postDifference > 1 ? [postDifference === FILL ? middle[middle.length - 1] + 1 : '...'] : [];
    list = [...list, ...preEllipsis, ...middle, ...postEllipsis, maxIndex];
    return {
        currentIndex: list.findIndex((index) => index === activeIndex),
        list: list.map((index) => ({
            label: addLeadingZero(index),
            disabled: index === '...',
            ...aria({
                current: index === activeIndex && 'page',
                // pagination is using aria-current as described here https://www.digitala11y.com/aria-current-state/ and not aria-selected which is useful for tabs therefore this overwrite
                selected: undefined,
                role: undefined,
                label: typeof index === 'number'
                    ? indexAriaLabel === null || indexAriaLabel === void 0 ? void 0 : indexAriaLabel({ index: addLeadingZero(index) })
                    : undefined,
            }),
        })),
    };
};
